// 18/10/2026 (Nelson: "está abrindo em uma nova aba e não nova janela"): a sala abre numa JANELA própria,
// do tamanho da tela, para a agenda/modal continuar aberta atrás. Usar no onClick do link "Entrar na sala".
export function abrirSala(ev, link) {
  if (!link) return;
  ev.preventDefault();
  const w = window.screen?.availWidth || 1280;
  const h = window.screen?.availHeight || 800;
  const janela = window.open(link, "_blank", `popup=yes,width=${w},height=${h},left=0,top=0`);
  if (!janela) window.location.href = link;   // bloqueador de pop-up: abre aqui mesmo
}
